import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';

import { FIELD_NAMES, HIN_REGEX, HIN_VALIDATION_MESSAGE } from '../..';
import { DBFormSchema, fieldProviderNpiSection, fieldTextSection, headerSection, spacerSection } from '..';
import { fieldSelectStatesSection, fieldTextLabel } from '../field-helpers';
import validatorTypes from '@data-driven-forms/react-form-renderer/dist/cjs/validator-types';
import { fieldCheckboxSection } from '../field-helpers';

const { prescriberFields } = FIELD_NAMES;

export const getAddPrescriberSchema = (schema: DBFormSchema): Schema => ({
  title: 'add prescriber form',
  fields: [
    fieldProviderNpiSection(prescriberFields.npi, schema?.[prescriberFields.npi], {
      sizes: { md: 5 }
    }),
    fieldTextLabel(prescriberFields.prescriber_ph_text, schema?.prescriber_ph_text, {
      label: "Begin typing to search for your Prescriber NPI #. If recognized,we'll pre-fill the available information",
      sizes: { md: 7 },
      color: '#212529'
    }),
    spacerSection(1, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldTextSection(prescriberFields.firstName, schema?.[prescriberFields.firstName], {
      sizes: { md: 6 },
      validate: [
        {
          type: 'name'
        }
      ]
    }),
    fieldTextSection(prescriberFields.lastName, schema?.[prescriberFields.lastName], {
      sizes: { md: 6 },
      validate: [
        {
          type: 'name'
        }
      ]
    }),
    spacerSection(2, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldTextSection(prescriberFields.email, schema?.[prescriberFields.email], {
      sizes: { md: 6 },
      validate: [
        {
          type: 'email'
        },
        {
          type: validatorTypes.PATTERN,
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
          message: 'Email is invalid'
        }
      ]
    }),
    fieldTextSection(prescriberFields.confEmail, schema?.[prescriberFields.confEmail], {
      sizes: { md: 6 },
      validate: [
        {
          type: 'same-as',
          strict: true,
          compareToField: prescriberFields.email
        },
        {
          type: 'email'
        },
        {
          type: validatorTypes.PATTERN,
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
          message: 'Email is invalid'
        }
      ]
    }),
    spacerSection(3, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldTextSection(prescriberFields.userName, schema?.[prescriberFields.userName], {
      sizes: { md: 6 },
      validate: [
        {
          type: 'name'
        }
      ]
    }),
    fieldTextSection(prescriberFields.cellNumber, schema?.[prescriberFields.cellNumber], {
      sizes: { md: 6 },
      type: 'tel',
      validate: [
        {
          type: 'phone-conditional'
        }
      ]
    }),
    spacerSection(4, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldSelectStatesSection(prescriberFields.licensingState, schema?.[prescriberFields.licensingState], {
      sizes: { md: 4 }
    }),
    fieldTextSection(prescriberFields.stateLicenseNumber, schema?.[prescriberFields.stateLicenseNumber], {
      sizes: { md: 4 }
    }),
    fieldTextSection(prescriberFields.taxId, schema?.[prescriberFields.taxId], {
      type: 'tax',
      sizes: { md: 4 },
      validate: [
        {
          type: 'tax-id'
        }
      ]
    }),
    spacerSection(5, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldTextSection(prescriberFields.ptan, schema?.[prescriberFields.ptan], {
      sizes: { md: 4 },
      validate: [
        {
          type: validatorTypes.PATTERN,
          pattern: /^(?![a-zA-Z]+$)[a-zA-Z0-9]+$/,
          message: 'PTAN needs to be in alphaNumeric  or numeric characters only'
        }
      ]
    }),
    fieldTextSection(prescriberFields.dea, schema?.[prescriberFields.dea], {
      sizes: { md: 4 }
    }),
    fieldTextSection(prescriberFields.hin, schema?.[prescriberFields.hin], {
      sizes: { md: 4 },
      validate: [
        {
          type: validatorTypes.PATTERN,
          pattern: HIN_REGEX,
          message: HIN_VALIDATION_MESSAGE
        }
      ]
    }),
    spacerSection(6, { sizes: { sm: 50 }, className: 'mb-4' }),
    fieldCheckboxSection('is_admin', schema?.is_admin, {
      sizes: { md: 6 },
      options: [{ value: true, label: 'Make this user an Administrator', customClassName: 'mb-2 admin-pres' }]
    })
  ]
});

// -----===[test schema]===-----
export const addPrescriberSchema: DBFormSchema = {
  prescriber_npi: { label: 'Prescriber NPI #:', required: true },
  prescriber_first_name: { label: 'First Name:', required: true },
  prescriber_last_name: { label: 'Last Name:', required: true },
  prescriber_email: { label: 'E-mail Address:', required: true },
  username: { label: 'username', required: true },
  prescriber_tax_id: { label: 'Tax ID # (TIN):' },
  prescriber_state_license_number: { label: 'State License #:' },
  dea: { label: 'DEA #:', required: true },
  prescriber_licensing_state: { label: 'Licensing State:', required: true },
  ptan: { label: 'PTAN #:', required: true },
  is_admin: {}
};
